module.exports = __webpack_public_path__ + "static/img/article.cda89bb3.svg";